import {
  FieldWrapper,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import {
  AgentThreadSourceMode,
  TSysAgentStepThreadSource,
} from '@commenda/types';

const THREAD_MODE_LABELS: Readonly<Record<AgentThreadSourceMode, string>> = {
  [AgentThreadSourceMode.NONE]: 'None',
  [AgentThreadSourceMode.ALL]: 'All threads, internal notes included',
};

interface IAgentThreadSourceFieldProps {
  source: TSysAgentStepThreadSource | undefined;
  onChange: (source: TSysAgentStepThreadSource) => void;
}

export const AgentThreadSourceField = ({
  source,
  onChange,
}: IAgentThreadSourceFieldProps) => {
  // An omitted source is read as all threads, so the field shows it that way.
  const mode = source?.mode ?? AgentThreadSourceMode.ALL;

  const onModeChange = (value: string) => {
    const nextMode = Object.values(AgentThreadSourceMode).find(
      (candidate) => candidate === value
    );
    if (nextMode) onChange({ mode: nextMode });
  };

  return (
    <FieldWrapper>
      <Label>Feed in threads</Label>
      <Select value={mode} onValueChange={onModeChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select which threads to feed in" />
        </SelectTrigger>
        <SelectContent>
          {Object.values(AgentThreadSourceMode).map((threadMode) => (
            <SelectItem key={threadMode} value={threadMode}>
              {THREAD_MODE_LABELS[threadMode]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FieldWrapper>
  );
};
